export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/attendance.97df3f13.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};